import React from 'react';
import { REPORTS_CONFIG } from '../../../utils/constants/reportsConstants';

const ReportContent = ({ selectedReport }) => {
  const CurrentReport = REPORTS_CONFIG[selectedReport]?.component;

  if (!CurrentReport) {
    return null;
  }

  return <CurrentReport />;
};

export default React.memo(ReportContent);
